<template>
  <div class="vx-card" id="create-remittance">
    <a-part-create
      @sendDataToBasePageCreate="sendDataToBasePageCreate"
    ></a-part-create>
    <div class="vx-card__body" v-show="showForm">
      <form>
        <div class="flex gap-4 flex-wrap md:flex-no-wrap items-end pb-6">
          <div class="md:w-1/2 w-full flex-shrink-0">
            <label class="vs-select--label">{{ $t("Product") }}</label>
            <treeselect
              v-model="transaction.stockId"
              name="stockid"
              :multiple="false"
              :placeholder="$t('Search')"
              :async="true"
              :load-options="loadOptions"
              :class="{ 'is-invalid': errors.has('stockid') }"
              v-validate="'required'"
              @select="onStockSelected"
            />
          </div>
          <div class="">
            <vs-input
              v-model="transaction.count"
              name="pcount"
              :label="$t('Count')"
              v-validate="{ regex: '^[1-9][0-9]*$', required: 'true' }"
              :class="{ 'is-invalid': errors.has('pcount') }"
            />
          </div>
          <div class="w-1/4">
            <label class="vs-select--label">{{ $t("Shelve") }}</label>
            <v-select
              label="name"
              name="shelve"
              :options="listOfShelvesRelated"
              v-model="transaction.shelveId"
              :reduce="(x) => x.id"
              v-validate="'required'"
              :class="{ 'is-invalid': errors.has('shelve') }"
              dir="rtl"
              :key="shelveIdControl"
            >
            </v-select>
          </div>
          <div class="">
            <vs-input
              class="inputx"
              placeholder="-"
              v-model="stockTypeName"
              :label="$t('Type')"
              readonly="readonly"
            />
          </div>
          <div class="">
            <vs-button
              color="success"
              type="gradient"
              class="px-4 flex gap-1 h-12"
              icon-pack="feather"
              icon="icon-plus"
              id="add-btn"
              @click.prevent="addItemToTransactionList()"
              >{{ $t("Add") }}</vs-button
            >
          </div>
        </div>
      </form>
      <vs-table :data="transactionList" class="custom-tbl">
        <template slot="thead">
          <th style="width: 5%">#</th>
          <th style="width: 30%">{{ $t("Product") }}</th>
          <th style="width: 5%">{{ $t("Count") }}</th>
          <th style="width: 10%">{{ $t("Shelve") }}</th>
          <th style="width: 50%">{{ $t("Action") }}</th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="i" v-for="(transaction, i) in data">
            <vs-td>
              {{ i + 1 }}
            </vs-td>
            <vs-td>
              {{ transaction.name }}
            </vs-td>
            <vs-td>
              {{ transaction.count }}
            </vs-td>
            <vs-td>
              {{ transaction.shelveName }}
            </vs-td>
            <vs-td>
              <div class="flex items-center gap-3 justify-center">
                <div v-if="transaction.stockType == 1">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="flex gap-2 h-10 px-2"
                    @click="addSerial(i)"
                    >{{ $t("SerialNumbers") }}</vs-button
                  >
                </div>
                <div
                  class="flex gap-y-2 flex-wrap"
                  v-if="transaction.stockType == 2"
                >
                  <div class="">
                    <vs-input
                      style="direction: ltr; min-width: 80px"
                      v-model="transaction.trackingId"
                      :placeholder="$t('TrackingId')"
                    />
                  </div>
                  <div class="">
                    <vs-input
                      style="direction: ltr; min-width: 80px"
                      v-model="transaction.guaranteeIdentification"
                      :placeholder="$t('GuaranteeIdentification')"
                    />
                  </div>
                </div>
                <div class="w-64">
                  <vs-input
                    class="w-full"
                    style="direction: ltr; min-width: 100px"
                    v-model="transaction.passagePermit"
                    :placeholder="$t('PassagePermit')"
                  />
                </div>

                <vs-button
                  radius
                  color="danger"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="deleteInventoryItem(i)"
                  class="d-inline remove-btn flex-shrink-0"
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="flex gap-4 w-full justify-end py-6">
        <vs-button type="filled" color="#3ec9d6" @click.prevent="resetForm">{{
          $t("Reset")
        }}</vs-button>
        <vs-button
          type="filled"
          @click.prevent="submitForm"
          :disabled="disabled || transactionList.length == 0"
          >{{ $t("Save") }}</vs-button
        >
      </div>
    </div>
    <serial-popup
      :serialsListSelected="serialsListSelected"
      :show="SerialPopup"
      @finish="onfinish"
      @updateSerialList="updateSerialList"
      :transactionCount="transactionCount"
    ></serial-popup>
  </div>
</template>

<style lang="scss">
// #reset-btn {
//   margin-left: 1.5rem;
//   background: #3ec9d6 !important;
// }

//
</style>

<script>
import { mapActions } from "vuex";
import "../../../assets/scss/vuesax-rtl/pages/_warehouse.scss";
import vSelect from "@/components/CustomVSelect.vue";
import APartCreate from "./APartOfCreate.vue";
import "../../../assets/scss/vuesax-rtl/pages/_warehouse.scss";
import { Validator } from "vee-validate";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import SerialPopup from "./SerialPopup.vue";

const dict = {
  custom: {
    shelve: {
      required: "لطفا نام انبار را انتخاب نمایید.",
    },
    date: {
      required: "لطفا تاریخ ثبت را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_CheckinTransactions_Create",
  components: {
    "v-select": vSelect,
    APartCreate,
    Treeselect,
    SerialPopup,
  },

  data() {
    return {
      transactionCount: 0,
      transaction: {},
      searchQueryNew: "",
      searchQueryOld: "",
      shelveIdControl: 0,
      checkInModelfinally: {},
      totalCount: [],
      transactionList: [],
      shelve: "",
      serialsListSelected: 0,
      stockTypeName: "-",
      SerialPopup: false,
      showForm: false,
      showBtn: true,
      setDisabled: false,
      listOfShelvesRelated: [],
      disabled: false,
    };
  },
  mounted() {
    this.setEmptyModel();
  },
  methods: {
    ...mapActions({
      addTransaction: "checkInTransactions/addTransaction",
      // setSelectedTransactionIndex:
      //   "checkInTransactions/setSelectedTransactionIndex",
      fetchSearch: "stock/fetchSearch",
      createCheckIn: "checkInTransactions/create",
      // checkSerialsCount: "checkInTransactions/checkSerialsCount"
    }),
    updateSerialList(serialList) {
      this.transactionList[this.updatedRow].serialsInfo = serialList;
    },
    sendDataToBasePageCreate(listOfShelvesRelated1, checkInModel) {
      this.listOfShelvesRelated = listOfShelvesRelated1;
      this.checkInModelfinally = checkInModel;
      this.showForm = true;
    },
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchSearch(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.stockId,
                  label: element.stockName,
                  stockType: element.stockType,
                  stockTypeName: element.stockType == 1 ? "سریالی" : "مقداری",
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onStockSelected(data) {
      this.$validator.reset();
      this.$validator.validateAll();
      this.transaction.name = data.label;
      this.transaction.stockType = data.stockType;
      this.stockTypeName = data.stockTypeName;
      this.transaction.destinationShelveId = null;
      this.transaction.destinationShelveName = null;
    },
    setEmptyModel() {
      this.transaction = {
        stockId: null,
        name: null,
        shelveId: null,
        shelveName: null,
        serialsInfo: [],
        count: 0,
        destinationShelveId: null,
        destinationShelveName: null,
        trackingId: null,
        passagePermit: null,
      };
      this.shelveIdControl = Math.random();
    },
    addItemToTransactionList() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.transaction.shelveName = this.listOfShelvesRelated.filter(
            (x) => x.id == this.transaction.shelveId
          )[0].name;

          this.transactionList.push(this.transaction);
          this.setEmptyModel();
          this.$validator.reset();
        }
      });
    },

    submitForm() {
      let transactions = JSON.parse(JSON.stringify(this.transactionList));
      for (let index = 0; index < transactions.length; index++) {
        if (transactions[index].stockType == 1) {
          if (
            transactions[index].count != transactions[index].serialsInfo.length
          ) {
            this.$swal({
              title:
                "تعداد سریال های وارد شده در جدول با سریال های ورودی متفاوت است!",
              type: "info",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "بستن",
            });
            return;
          }
          transactions[index].count = 0;
        } else transactions[index].count = Number(transactions[index].count);
      }
      this.checkInModelfinally.inventoryTransactionItemCommands = transactions;
      this.disabled = true;
      this.createCheckIn(this.checkInModelfinally)
        .then(() => {
          setTimeout(() => {
            this.$router.push("/CheckInTransactions/Index");
          }, 3000);
        })
        .catch(() => {
          console.log(this.transactionList);
          this.disabled = false;
        });
    },
    resetForm() {
      this.$router.go(this.$router.currentRoute);
    },
    onfinish() {
      this.$validator.reset();
      this.SerialPopup = false;
    },
    addSerial(index) {
      this.updatedRow = index;
      this.serialsListSelected = this.transactionList[index].serialsInfo;
      this.transactionCount = this.transactionList[index].count;
      this.SerialPopup = true;
    },
    deleteInventoryItem(index) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.updatedRow = null;
          this.serialsListSelected = null;
          this.transactionCount = null;
          this.transactionList.splice(index, 1);
        }
      });
    },
  },
};
</script>
